'use client';

import { useEffect } from 'react';

export default function HashScrollFix() {
    useEffect(() => {
        const handleClick = (event: MouseEvent) => {
            if (event.button !== 0) return;
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

            const anchor = (event.target as HTMLElement | null)?.closest('a');
            if (!anchor) return;
            if (anchor.target && anchor.target !== '' && anchor.target !== '_self') return;
            if (anchor.hasAttribute('download')) return;

            const href = anchor.getAttribute('href');
            if (!href) return;

            let url: URL;
            try {
                url = new URL(href, window.location.href);
            } catch {
                return;
            }

            if (url.origin !== window.location.origin) return;
            if (!url.hash || url.hash === '#') return;

            const normalize = (path: string) => path.replace(/\/+$/, '') || '/';
            if (normalize(url.pathname) !== normalize(window.location.pathname)) return;

            const id = decodeURIComponent(url.hash.slice(1));
            const el = document.getElementById(id);
            if (!el) return;

            // preventDefault alone is enough: next/link bails on an already
            // prevented event. stopImmediatePropagation would also swallow the
            // event before React's delegated listener, so onClick handlers such
            // as the mobile menu's close would never run.
            event.preventDefault();

            el.scrollIntoView({ behavior: 'smooth', block: 'start' });

            if (window.location.hash !== url.hash) {
                history.pushState(null, '', url.hash);
            }
        };

        document.addEventListener('click', handleClick, true);
        return () => document.removeEventListener('click', handleClick, true);
    }, []);

    return null;
}
